import { MapRequestService } from './map-request.service';
import { EbwModalService } from '@ebw-monorepo/modal';
import { I18NService } from '@ebw-monorepo/i18n-translate';
import { IHttpMapGet, IHttpRequest } from './../interfaces/httpReq.interface';
import { MapService } from '@ebw-monorepo/map';
import { Injectable } from '@angular/core';
import { catchError, firstValueFrom, map, Observable } from 'rxjs';
import { API_URLS, ApiUrlService } from 'libs/ng-components/utils/src/lib/services/api-url.service';
import { LoginService } from '@ebw-monorepo/login';

@Injectable({
  providedIn: 'root'
})
export class BookmarkService {
  private activeLayers = [];
  constructor(
    private mapService: MapService,
    private ebwModalSrv: EbwModalService,
    private i18nSrv: I18NService,
    private httpSrv: MapRequestService,
    private _apiUrlService: ApiUrlService
  ) {}

  getCurrentLayer(): string {
    //recupero i layers visibili
    let activeLayersArr = Array.from(this.mapService.activeLayers.values())
      .filter((a) => a.getVisible())
      .map((a) => a.get(MapService.ID_LAYER_KEY));
    let worldLayersArr = Array.from(this.mapService.worldLayers.values())
      .filter((a) => a.getVisible())
      .map((a) => a.get(MapService.ID_LAYER_KEY));

    this.activeLayers = Object.assign([], activeLayersArr.concat(worldLayersArr));

    return this.activeLayers.toString();
  }

  positioningOnMap(bbox: any, activeLayers: string) {
    this.layersHandler(activeLayers, true);
    this.mapService.centerMapOnGeometry(bbox);
  }

  /**
*  Gestore di attivazione dei layers della view caricata: Disattivo quelli del portale e attivo quelli della view e viceversa.
* @param layers : nomi di layers separati da virgola
@param on boolean che setta la visibilità a true o false
*/
  layersHandler(layers: string, on: boolean = true) {
    if (layers) {
      let viewLayers = layers.split(',');
      viewLayers.forEach((vw: string) => {
        let vectorActiveLayers = this.mapService.activeLayers.get(vw);
        let vectorWorldLayers = this.mapService.worldLayers.get(vw);
        if (vectorActiveLayers) {
          this.mapService.setLayerVisibility(vw, on);
        } else if (vectorWorldLayers) {
          this.mapService.changeWorldLayer(vw);
        }
      });
    }
  }

  deleteBookmark(id: number) {
    const req: IHttpMapGet = {
      url: this._apiUrlService.createUrl(API_URLS.MAP.BOOKMARK.DELETE)
    };

    const body = {
      id: id
    };
    return this.httpSrv.postMapRequest(req, body);
  }

  setLayerAsFavourite(req: IHttpRequest, bookmarkId: number, userId: string, toDelete: boolean): Observable<any> {
    const body = { bookmarkId, userId, toDelete };

    return this.httpSrv.postMapRequest(req, body).pipe(
      map((resp: any) => {
        if (resp && resp.error == 0) {
          this.ebwModalSrv.openSuccessModal({
            title: this.i18nSrv.getInstantValue(
              toDelete ? 'common.unsetFavouriteBookmarkMessageSuccess' : 'common.favouriteBookmarkMessageSuccess'
            ),
            content: this.i18nSrv.getInstantValue(
              toDelete ? 'common.unsetFavouriteBookmarkMessageSuccess' : 'common.favouriteBookmarkMessageSuccess'
            )
          });
        }
        return resp;
      }),
      catchError((error) => {
        this.ebwModalSrv.openErrorModal({
          title: this.i18nSrv.getInstantValue(
            toDelete ? 'common.removingFavouriteBookmarkMessageError' : 'common.favouriteBookmarkMessageError'
          ),
          content: this.i18nSrv.getInstantValue(
            toDelete ? 'common.removingFavouriteBookmarkMessageError' : 'common.favouriteBookmarkMessageError'
          )
        });
        throw error;
      })
    );
  }

  getFavouriteBookmark(url: string): Promise<any> {
    // TODO piccone: rimuovere oggetti IHttpMapGet e IHttpRequest
    return firstValueFrom(this.httpSrv.getMapRequest({ url: url }));
  }
}
